import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useMetadata } from '../../../providers/MetadataContext';

function InvestorDetailsInvestmentHorizonField({ value, setValue }) {
  const metadata = useMetadata();
  const [selected, setSelected] = useState(
    (metadata?.user?.lists?.investment_horizons || []).find(
      (option) => option.entity_id === value
    )
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    setValue(newValue?.entity_id);
  };

  return (
    <Box>
      <Autocomplete
        id='investment-horizon-field'
        options={metadata?.user?.lists?.investment_horizons || []}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        renderInput={(params) => (
          <TextField {...params} label='Investment Horizon' />
        )}
      />
    </Box>
  );
}

export default InvestorDetailsInvestmentHorizonField;
